/*
* @TagDialog.vue.vue  uwb基站配置
* @Description
* @Author zhangbin
* @Date 2021/6/28
*/
/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog forms-box"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >
        <el-form label-width="120px">
            <el-form-item class="row-items-2" label="访问地址：">
                {{logForm.requestIp}}
            </el-form-item>
            <el-form-item class="row-items-2" label="请求路径：">
                {{logForm.requestUri}}
            </el-form-item>
            <el-form-item class="row-items-2" label="请求方法：">
                {{logForm.requestMethod}}
            </el-form-item>
            <el-form-item class="row-items-2" label="请求版本号：">
                {{logForm.requestVer}}
            </el-form-item>
            <el-form-item class="row-items-1" label="请求头部：">
                {{logForm.requestHeader}}
            </el-form-item>
            <el-form-item class="row-items-1" label="请求参数：">
                {{logForm.requestParam}}
            </el-form-item>
            <el-form-item class="row-items-1" label="异常名称：">
                {{logForm.excName}}
            </el-form-item>
            <el-form-item class="row-items-1" label="异常日志：">
                {{logForm.excMessage}}
            </el-form-item>
            <el-form-item class="row-items-1" label="操作人：" v-if="logForm.requestUserName">
                {{logForm.requestUserName}}
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

/* JS */
<script>

    export default {
        /**
         * @Des 组件名
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        name: "OperateLogDialog",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 2021/7/1
         */
        components: {
        },
        props:{
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 08:46 2021/6/29
         */
        data() {
          return {
              // 弹出层属性
              dialogForm: {
                  title: "",
                  dialogFormVisible: false,
                  editState: 0
              },
              logForm: {},
              index: -1,
          }
        },
        created(){
        },
        mounted() {
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 10:21 2021/6/28
         */
        methods: {
            /**
             * @Des 打开弹出层
             * @Auth jsh
             * @Date 09:46 2021/6/28
             */
            openDialog(data, index, state) {
                // console.log(data);
                this.dialogForm.title = '异常日志明细';
                // 赋值
                this.setData(data, index);
                if(state){
                    this.dialogForm.editState = state;
                }
                this.dialogForm.dialogFormVisible = true;
            },

            /**
             * 设置值
             * */
            setData(data, index) {
                this.logForm = Object.assign(this.logForm, data);
                this.index = index;
            },
            /**
             * @Des 弹窗关闭
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            handleDialogClose() {
                this.reset();
            },
            /**
             * @Des 重置
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            reset() {
                this.cleanValidate('logForm');
                this.cleanData();
            },

            /**
             * @Des 清除表单验证
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanValidate(formName) {
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清除数据
             * @Auth jsh
             * @Date 15:31 2021/6/28
             */
            cleanData() {
                // 将数据置为空
                this.logForm = Object.assign({}, {});
                // 是否编辑
                this.dialogForm.editState = 0;
                this.index = -1;
            },
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
	    width: 90%;
	}
	/deep/ .form-dialog.forms-box .el-form-item {
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Log/ExceptionLogDialog.vue